import { motion } from "framer-motion";
import { MathRichText } from "@/lib/mathRichText";

interface Props {
  data: {
    type: "process_flow";
    title?: string;
    steps: { icon?: string; label: string; detail: string }[];
    animation?: string;
  };
}

export function ElementProcessFlow({ data }: Props) {
  const steps = data.steps ?? [];
  return (
    <motion.div
      className="space-y-2"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      {data.title && <p className="font-semibold text-slate-800">{data.title}</p>}
      <div className="flex flex-wrap items-stretch gap-2">
        {steps.map((step, i) => (
          <motion.div
            key={i}
            className="flex gap-2 items-start p-3 rounded-lg border-2 border-slate-200 bg-slate-50 min-w-0 flex-1"
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.06 }}
          >
            {i > 0 && <span className="text-slate-400 shrink-0">→</span>}
            {step.icon && <span className="shrink-0">{step.icon}</span>}
            <div>
              <p className="font-medium text-slate-800 text-sm"><MathRichText text={step.label} /></p>
              <p className="text-slate-600 text-xs mt-0.5"><MathRichText text={step.detail} /></p>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
}
